import { render, staticRenderFns } from "./ModalGallery.vue?vue&type=template&id=26b90106&scoped=true&"
import script from "./ModalGallery.vue?vue&type=script&lang=js&"
export * from "./ModalGallery.vue?vue&type=script&lang=js&"
import style0 from "./ModalGallery.vue?vue&type=style&index=0&id=26b90106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b90106",
  null
  
)

export default component.exports